import styled from "@emotion/styled"

import helpIcon from "../../../images/help-popover-icon.svg"

const HelpPopoverIcon = styled.div<{ css?: any }>`
  background-image: url(${helpIcon});
  background-repeat: no-repeat;
  background-size: cover;
  width: 19px;
  height: 19px;
  ${props => props.css}
`

export default HelpPopoverIcon
